export default __webpack_public_path__ + "static/media/logo-figaro.14392f73.svg";